export class BaseFilterClass {
    constructor(fieldName: string) {
        this.fieldName = fieldName;
    }
    protected fieldName: string;
    protected genericFilter: any[] = [];
    public static flatten = filter => {
        const filters = (filter || {}).filters;
        if (filters) {
            return filters.reduce((acc, curr) => acc.concat(curr.filters ? BaseFilterClass.flatten(curr) : [curr]), []);
        }
        return [];
    };
}